<template>
  <div>
    <title-edit header="User role" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12" style="text-align: right">
        <v-app class="switch-app">
          <v-switch label="Active" v-model="form.status"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Role name* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.role_name" @update="updateRoleName"/>
      </v-col>
    </div>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(permission,index) in permissionRoleList">
            <tr>
              <td>{{++index}}</td>
              <td>{{permission.feature_name}}</td>
              <td>
                <div style="height: 40px ; text-align: left">
                  <v-select
                    :items="permissionOption"
                    background-color="#ffffff"
                    outlined
                    v-model="permission.permission_id"
                    style="border-radius: 30px; text-align: left!important;"
                    dense
                  ></v-select>
                </div>
              </td>
            </tr>
          </template>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <line-hr />
    <command-button @delete-info="deleteUserRole" @save-info="saveUserRole" @save-close="saveClose"></command-button>
<!--    <pre>{{permissionRoleList}}</pre>-->
  </div>
</template>

<script>
  import TitleEdit from "../../../components/TitleHeader/TitleEdit";
  import InputTextField from "../../../components/Input/InputTextField";
  import InputEditor from "../../../components/Input/InputEditor";
  import SelectOption from "../../../components/Input/selectOption";
  import InputImageUpload from "../../../components/Input/InputImageUpload";
  import LineHr from "../../../components/Icon/line-hr";
  import DeleteButton from "../../../components/Button/DeleteButton";
  import PreviewButton from "../../../components/Button/PreviewButton";
  import SaveButton from "../../../components/Button/SaveButton";
  import SwitchSelect from "../../../components/Input/StyleUtility";
  import { mapState } from "vuex";
  import Swal from "sweetalert";
  import CommandButton from "../../../components/Layout/CommandButton";
  export default {
    name: "UserRoleEdit",
    components: {
      CommandButton,
      SwitchSelect,
      SaveButton,
      PreviewButton,
      DeleteButton,
      LineHr,
      InputImageUpload,
      SelectOption,
      InputEditor,
      InputTextField,
      TitleEdit
    },
    computed: {
      ...mapState({
        form: state => {
          return state.UserRole.form;
        }
      })
    },
    created() {
      this.getPermission();
      if(this.form.permission.length > 0 && this.form.permission[0].feature_name){
        this.permissionRoleList = this.form.permission;
      }else{
        this.getAllFeature();
      }
    },
    data() {
      return {
        optionVenueHire: [],
        optionFloor: [],
        permissionOption : [],
        headers: [
          { id: 1, text: "No." },
          { id: 2, text: "Feature" },
          { id: 3, text: "Access code" },
        ],
        permissionRoleList : [],
        save_id: null
      };
    },
    methods: {
      getPermission(){
        this.$store.dispatch("Permission/getAllPermission").then(res=>{
          this.permissionOption = [
            ...res.map(data => ({
              value: data.id,
              text: data.name,
            }))
          ];
        })
      },
      getAllFeature(){
        this.$store.dispatch("UserRole/getAllFeature").then(res=>{
          this.permissionRoleList = [
            ...res.map(data => ({
              feature_id : data.id,
              feature_name: data.name,
              permission_id: null,
            }))
          ];
        })
      },
      goToUserRoleTable() {
        this.$router.push("/user-role");
      },
      validateSave() {
        if(!this.form.role_name){
          Swal('','Please input role name','error');
          return  false;
        }
        return true;
      },
      saveClose() {
        this.form.permission = this.permissionRoleList;
        if(this.validateSave()){
          this.$store.dispatch("UserRole/saveUserRole",{
            id : this.save_id ? this.save_id : this.form.id,
            data : this.form
          }).then(res=>{
            Swal(res.response_msg);
            if(res.response_code == 200){
              this.goToUserRoleTable();
            }
          }).catch(()=>{
            Swal('','Cannot save user role','error');
          })
        }
      },
      saveUserRole() {
        this.form.permission = this.permissionRoleList;
        if(this.validateSave()){
          this.$store.dispatch("UserRole/saveUserRole",{
            id : this.save_id ? this.save_id : this.form.id,
            data : this.form
          }).then(res=>{
            this.save_id = res.result.id;
            Swal(res.response_msg);
          }).catch(()=>{
            Swal('','Cannot save user role','error');
          })
        }
      },
      deleteUserRole() {
        this.$store.dispatch("UserRole/deleteUserRole",this.form.id).then(res=>{
          Swal(res.response_msg);
          if(res.response_code == 200){
            this.goToUserRoleTable();
          }
        }).catch(()=>{
          Swal('','Cannot delete user role','error');
        })
      },
      updateRoleName(val){
        this.form.role_name = val;
      }
    }
  };
</script>

<style scoped>
  .label {
    text-align: right;
  }
</style>
